import { type RouteRecordRaw } from 'vue-router';

function createRoute(tab: string): RouteRecordRaw {
  return {
    name: `details${tab}`,
    path: tab.toLowerCase(),
    component: () => import(`../Polissen/details/tabs/Polisdetails${tab.replace('-', '')}.vue`),
    props: (route) => ({
      polisnummer: route.params.polisnummer,
      relatienummer: route.params.relatienummer,
    }),
    meta: { label: 'Polis', title: tab },
  };
}

const routes: Array<RouteRecordRaw> = [
  createRoute('Algemeen'),
  createRoute('Branchegegevens'),
  createRoute('Dekkingen'),
  createRoute('Clausules'),
  createRoute('Voorwaarden'),
  createRoute('Polistekst'),
  createRoute('Roy-data'),
];

export default routes;
